import { Component, Input, OnInit } from '@angular/core';
import { FilterType } from 'src/app/library/enums/filters/filter.enum';
import { IFilter } from 'src/app/library/interfaces/filters/filter';

@Component({
    selector: 'filter-selected-filters',
    templateUrl: './filter-selected-filters.component.html',
    styleUrls: ['./filter-selected-filters.component.scss']
})
export class FilterSelectedFiltersComponent implements OnInit {
    @Input() selectedFilters: IFilter[];

    public filterTypeEnum = FilterType;

    constructor() {}

    ngOnInit() {}
}
